import React from "react";
import CircleIcon from '@mui/icons-material/Circle';



export default function TrafficlightButtonOrange() {
return(

    <CircleIcon sx={{fontSize: '170%', color: 'traffic.orange' }} />
)
}